import $api from "../../../../../services/axiosService";
import { createCertificateRequestInfoAction } from "../createCertificateRequestInfo.action";

export let status;
export const checkStatus = (issueId) => {
    return new Promise((resolve, reject) => {
        const poll = () => {
            setTimeout(async () => {
                try {
                    const resp = await $api(`v1/c/certificates/issues/${issueId}`);
                    const data = resp.data;

                    switch (data.status) {
                    case 0:  // ожидание
                        poll(); // продолжаем опрос
                        break;

                    case 60:  // успех

                        resolve(data); // завершаем Promise успехом
                        break;

                    default:
                        reject("Что-то пошло не так, повторите попытку позже");
                    }
                } catch (e) {
                    reject(e);
                }
            }, 1000);
        };

        poll(); // запускаем первый опрос
    });
};


export const createCertificateRequestInfoThunkAction = (data, props) => async (dispatch) => {
    try {
        const response = await $api.post("v1/c/certificates", data);
        if (response.status) {
            await checkStatus(response.data.issueId);

            dispatch(createCertificateRequestInfoAction(response.data));

            return props.setLoader(false);


        }
    } catch (e) {
        props.setLoader(false);
        const detail = e?.response?.data?.detail;
        const message = detail && /[а-яёА-ЯЁ]/.test(detail)
            ? detail
            : "Что-то пошло не так, повторите попытку позже";
        return props.setDescription(message);
    }
};
